<template>
  <div class="config">
    <!-- class="container-cards " :class="computedClass" -->


    <b-modal
      ref="formOptions"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitOptions"
      size="sm"

    >
      <h6>{{ titleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitOptions">
        <b-form-text id="optNumInputLiveHelp">
          <label for="optNumInput">Nº identificador *</label>
        </b-form-text>
        <b-form-input
          v-model="form.NUM"
          type="number"
          min="1"
          placeholder="Nº identificador *"
          aria-describedby="optNumInputLiveHelp optNumInputLiveFeedback"
          :state="numState"
          id="optNumInput"
        >
        </b-form-input>
        <b-form-invalid-feedback v-if="!numState" id="optNumInputLiveFeedback">
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="optNameInputLiveHelp">
          <label for="optNameInput">Nome *</label>
        </b-form-text>
        <b-form-input
          v-model="form.NAME"
          placeholder="Nome *"
          aria-describedby="optNameInputLiveHelp optNameInputLiveFeedback"
          :state="nameState"
          maxlength="24"
          id="optNameInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!nameState"
          id="optNameInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>
    <b-modal
      ref="deleteOptions"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmDelete"
      cancel-title="Cancelar"
      @cancel="resetPage"
    >
      <h4>{{ titleDialog }}</h4>
    </b-modal>

    <b-modal
      ref="formFarmAssociated"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetFarmAssociatedPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitFarmAssociated"
      size="sm"
    >
      <h6>{{ farmAssociatedTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitFarmAssociated">
        <b-form-text id="farmAssociatedNameInputLiveHelp">
          <label for="farmAssociatedNameInput">Nome *</label>
        </b-form-text>
        <b-form-input
          v-model="farmAssociatedForm.NAME"
          placeholder="Nome *"
          aria-describedby="farmAssociatedNameInputLiveHelp farmAssociatedNameInputLiveFeedback"
          :state="farmAssociatedNameState"
          maxlength="100"
          id="farmAssociatedNameInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!farmAssociatedNameState"
          id="farmAssociatedNameInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="farmAssociatedUrlInputLiveHelp">
          <label for="farmAssociatedUrlInput">URL *</label>
        </b-form-text>
        <b-form-input
          v-model="farmAssociatedForm.URL"
          placeholder="http://outro-cir.3v3.farm"
          aria-describedby="farmAssociatedUrlInputLiveHelp farmAssociatedUrlInputLiveFeedback"
          :state="farmAssociatedUrlState"
          maxlength="100"
          id="farmAssociatedUrlInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!farmAssociatedUrlState"
          id="farmAssociatedUrlInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>
    <b-modal
      ref="deleteFarmAssociated"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmDeleteFarmAssociated"
      cancel-title="Cancelar"
      @cancel="resetFarmAssociatedPage"
    >
      <h4>{{ farmAssociatedTitleDialog }}</h4>
    </b-modal>

    <div :class="computedClass">
      <div class="col-xs-12 p-xs-2 p-sm-0 p-xl-0">
        <div :class="computedClassHeader">Configuração / Avançado</div>
        <div class="row start-xs mt-2 col-xs-12 m-0">
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Tipos de sensores</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="types"
              :fields="fields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAll('t')"
                  v-model="allTypeSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selType"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selType.length == 1"
                @click="edit('t')"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="add('t')"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selType.length"
                @click="del('t')"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Unidades de sensores</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="units"
              :fields="fields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAll('u')"
                  v-model="allUnitSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selUnit"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selUnit.length == 1"
                @click="edit('u')"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="add('u')"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selUnit.length"
                @click="del('u')"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Interface de sensores</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="interfaces"
              :fields="fields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAll('i')"
                  v-model="allInterfaceSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selInterface"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selInterface.length == 1"
                @click="edit('i')"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="add('i')"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selInterface.length"
                @click="del('i')"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>CIRs associados</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="farmsAssociated"
              :fields="farmAssociatedFields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAllFarmAssociated"
                  v-model="allFarmAssociatedSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selFarmAssociated"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selFarmAssociated.length == 1"
                @click="editFarmAssociated"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="addFarmAssociated"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selFarmAssociated.length"
                @click="delFarmAssociated"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modelsSensor, session } from "@/api";

export default {
  name: "options",
  props: {
    mobile: Boolean,
  },
  created() {
    modelsSensor
      .types()
      .then((types) => {
        this.types = types;
        return modelsSensor.units();
      })
      .then((units) => {
        this.units = units;
        return modelsSensor.interfaces();
      })
      .then((interfaces) => {
        this.interfaces = interfaces;
      })
      .catch((err) => {
        alert("Ocorreu um erro. Recarregue a página.");
        console.log(err);
      });
    this.attFarmAssociatedList();
  },
  data() {
    return {
      fields: [
        {
          key: "CHECK",
          label: "",
        },
        {
          key: "NUM",
          label: "Nº",
        },
        {
          key: "NAME",
          label: "Nome",
        },
      ],
      farmAssociatedFields: [
        {
          key: "CHECK",
          label: "",
        },
        {
          key: "NAME",
          label: "Nome",
        },
        {
          key: "URL",
          label: "URL",
        },
      ],
      types: [],
      units: [],
      interfaces: [],
      farmsAssociated: [],
      allTypeSelected: false,
      allUnitSelected: false,
      allInterfaceSelected: false,
      allFarmAssociatedSelected: false,
      selType: [],
      selUnit: [],
      selInterface: [],
      selFarmAssociated: [],
      selected: {},
      farmAssociatedSelected: {},
      form: {
        NUM: null,
        NAME: null,
      },
      farmAssociatedForm: {
        NAME: null,
        URL: null,
      },
      card: null,
      titleDialog: "",
      farmAssociatedTitleDialog: "",
    };
  },
  watch: {
    selType() {
      this.allTypeSelected = this.selType.length == this.types.length;
    },
    selUnit() {
      this.allUnitSelected = this.selUnit.length == this.units.length;
    },
    selInterface() {
      this.allInterfaceSelected =
        this.selInterface.length == this.interfaces.length;
    },
    selFarmAssociated() {
      this.allFarmAssociatedSelected =
        this.selFarmAssociated.length == this.farmsAssociated.length;
    },
  },
  computed: {
    computedClass() {
      if (this.mobile) {
        return "row mobile-header p-2";
      }
      return "row desktop-header w-100 mt-2 col-xs-12 ml-0 mr-0 p-0";
    },
    computedClassHeader() {
      if (this.mobile) {
        return "page-title config-title-mobile col-xs-12  mt-0";
      }
      return "page-title config-title col-xs-12  mt-2";
    },
    numState() {
      return this.form.NUM != null && this.form.NUM != "";
    },
    nameState() {
      return this.form.NAME != "" && this.form.NAME != null;
    },
    farmAssociatedNameState() {
      return (
        this.farmAssociatedForm.NAME != "" &&
        this.farmAssociatedForm.NAME != null
      );
    },
    farmAssociatedUrlState() {
      return (
        this.farmAssociatedForm.URL != "" && this.farmAssociatedForm.URL != null
      );
    },
  },
  methods: {
    toggleAll(type) {
      if (type == "t") {
        this.allTypeSelected = !this.allTypeSelected;
        if (this.selType.length < this.types.length) {
          this.selType = this.types.slice();
        } else if (this.selType.length == this.types.length) {
          this.selType = [];
        }
      } else if (type == "u") {
        this.allUnitSelected = !this.allUnitSelected;
        if (this.selUnit.length < this.units.length) {
          this.selUnit = this.units.slice();
        } else if (this.selUnit.length == this.units.length) {
          this.selUnit = [];
        }
      } else if (type == "i") {
        this.allInterfaceSelected = !this.allInterfaceSelected;
        if (this.selInterface.length < this.interfaces.length) {
          this.selInterface = this.interfaces.slice();
        } else if (this.selInterface.length == this.interfaces.length) {
          this.selInterface = [];
        }
      }
    },
    add(card) {
      this.resetPage();
      this.card = card;
      if (card == "t") {
        this.titleDialog = "Adicionar tipo de sensor";
      } else if (card == "u") {
        this.titleDialog = "Adicionar unidade de sensor";
      } else if (card == "i") {
        this.titleDialog = "Adicionar interface de sensor";
      }
      this.$refs.formOptions.show();
    },
    edit(card) {
      this.card = card;
      if (card == "t") {
        this.selected = this.selType[0];
        this.titleDialog = `Editar tipo de sensor ${this.selected.NAME}`;
      } else if (card == "u") {
        this.selected = this.selUnit[0];
        this.titleDialog = `Editar unit de sensor ${this.selected.NAME}`;
      } else if (card == "i") {
        this.selected = this.selInterface[0];
        this.titleDialog = `Editar interface de sensor ${this.selected.NAME}`;
      }
      this.form = {
        NAME: this.selected.NAME,
        NUM: this.selected.NUM,
      };
      this.$refs.formOptions.show();
    },
    del(card) {
      this.card = card;
      if (card == "t") {
        this.selected = {
          table: "TYPE_OPTIONS",
          items: this.selType,
        };
        this.titleDialog =
          this.selType.length +
          (this.selType.length == 1
            ? " tipo de sensor será excluído."
            : " tipos de sensor serão excluídos.");
      } else if (card == "u") {
        this.selected = {
          table: "UNIT_OPTIONS",
          items: this.selUnit,
        };
        this.titleDialog =
          this.selUnit.length +
          (this.selUnit.length == 1
            ? " unidade de sensor será excluída."
            : " unidades de sensor serão excluídas.");
      } else if (card == "i") {
        this.selected = {
          table: "INTERFACE_OPTIONS",
          items: this.selInterface,
        };
        this.titleDialog =
          this.selInterface.length +
          (this.selInterface.length == 1
            ? " interface de sensor será excluída."
            : " interfaces de sensor serão excluídas.");
      }
      this.$refs.deleteOptions.show();
    },
    confirmDelete() {
      modelsSensor
        .optionsDelete(this.selected)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attList(this.card);
        })
        .catch((err) => console.log(err));
    },
    submitOptions() {
      let table = "";
      if (this.card == "t") {
        table = "TYPE_OPTIONS";
      } else if (this.card == "u") {
        table = "UNIT_OPTIONS";
      } else if (this.card == "i") {
        table = "INTERFACE_OPTIONS";
      }
      let data = {
        ID: this.selected.ID ? this.selected.ID : null,
        NUM: this.form.NUM,
        NAME: this.card == "i" ? this.form.NAME.toUpperCase() : this.form.NAME,
        table,
      };
      if (data.ID) {
        modelsSensor
          .optionsEdit(data)
          .then((ret) => {
            alert(ret.log, ret.alert);
            this.attList(this.card);
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro. Recarregue a página.");
          });
      } else {
        modelsSensor
          .optionsAdd(data)
          .then((ret) => {
            alert(ret.log, ret.alert);
            this.attList(this.card);
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro. Recarregue a página.");
          });
      }
      this.$refs.formOptions.hide();
    },
    attList(card) {
      if (card == "t") {
        modelsSensor
          .types()
          .then((types) => {
            this.types = types;
          })
          .catch((err) => {
            alert(
              "Ocorreu um erro ao atualizar lista de tipos. Recarregue a página."
            );
            console.log(err);
          });
      } else if (card == "u") {
        modelsSensor
          .units()
          .then((units) => {
            this.units = units;
          })
          .catch((err) => {
            alert(
              "Ocorreu um erro ao atualizar lista de unidades. Recarregue a página."
            );
            console.log(err);
          });
      } else if (card == "i") {
        modelsSensor
          .interfaces()
          .then((interfaces) => {
            this.interfaces = interfaces;
          })
          .catch((err) => {
            alert(
              "Ocorreu um erro ao atualizar lista de interfaces. Recarregue a página."
            );
            console.log(err);
          });
      }
      this.resetPage();
    },
    resetPage() {
      this.form = {
        NUM: null,
        NAME: null,
      };
      this.card = null;
      this.allTypeSelected = false;
      this.allUnitSelected = false;
      this.allInterfaceSelected = false;
      this.selType = [];
      this.selUnit = [];
      this.selInterface = [];
      this.selected = {};
      this.titleDialog = "";
    },
    toggleAllFarmAssociated() {
      this.allFarmAssociatedSelected = !this.allFarmAssociatedSelected;
      if (this.selFarmAssociated.length < this.farmsAssociated.length) {
        this.selFarmAssociated = this.farmsAssociated.slice();
      } else if (this.selFarmAssociated.length == this.farmsAssociated.length) {
        this.selFarmAssociated = [];
      }
    },
    addFarmAssociated() {
      this.resetFarmAssociatedPage();
      this.farmAssociatedTitleDialog = "Adicionar CIR associado";
      this.$refs.formFarmAssociated.show();
    },
    editFarmAssociated() {
      this.farmAssociatedSelected = this.selFarmAssociated[0];
      this.farmAssociatedTitleDialog = `Editar CIR ${this.farmAssociatedSelected.NAME}`;
      this.farmAssociatedForm = {
        NAME: this.farmAssociatedSelected.NAME,
        URL: this.farmAssociatedSelected.URL,
      };
      this.$refs.formFarmAssociated.show();
    },
    delFarmAssociated() {
      this.farmAssociatedSelected = { items: this.selFarmAssociated };
      this.farmAssociatedTitleDialog =
        this.selFarmAssociated.length +
        (this.selFarmAssociated.length == 1
          ? " CIR associado será excluído."
          : " CIRs associados serão excluídos.");
      this.$refs.deleteFarmAssociated.show();
    },
    confirmDeleteFarmAssociated() {
      session
        .deleteFarmAssociated(this.farmAssociatedSelected.items)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attFarmAssociatedList();
        })
        .catch((err) => console.log(err));
    },
    submitFarmAssociated() {
      let data = {
        ID: this.farmAssociatedSelected.ID
          ? this.farmAssociatedSelected.ID
          : null,
        NAME: this.farmAssociatedForm.NAME,
        URL: this.farmAssociatedForm.URL,
      };
      let request = data.ID
        ? session.editFarmAssociated(data)
        : session.addFarmAssociated(data);

      request
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attFarmAssociatedList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formFarmAssociated.hide();
    },
    attFarmAssociatedList() {
      session
        .getFarmsAssociated()
        .then((farmsAssociated) => {
          this.farmsAssociated = farmsAssociated;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar lista de CIRs associados. Recarregue a página."
          );
          console.log(err);
        });
      this.resetFarmAssociatedPage();
    },
    resetFarmAssociatedPage() {
      this.farmAssociatedForm = {
        NAME: null,
        URL: null,
      };
      this.allFarmAssociatedSelected = false;
      this.selFarmAssociated = [];
      this.farmAssociatedSelected = {};
      this.farmAssociatedTitleDialog = "";
    },
  },
};
</script>

<style scoped>
.card-body {
  height: 60vh;
  overflow: auto;
}
.mobile-header{
  margin-top: 26px;
}
.config-title {
  max-height: 1.1em;
  /* padding: 0 0 4px 0; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.config-title-mobile {
  top: 60px;
}
@media screen and (max-width: 767px) {
  .card-text {
    font-size: 0.88em;
  }
}
.card-text > div > p {
  color: var(--text-gray-primary);
}
</style>
